module.exports = __webpack_public_path__ + "img/cave_painting_in_the_subway.2ced3b1e.jpg";